import { jsxs as d, jsx as i } from "react/jsx-runtime";
import { useState as b, useMemo as z, isValidElement as E, useEffect as S } from "react";
import { StepWizardEvents as u } from "./hooks/useStepWizard.js";
import { HorizontalDivider as T, ActionsContainer as A } from "./styles.js";
import { Flex as L } from "../Flex/Flex.js";
import { HorizontalPageCounter as V } from "./components/HorizontalPageCounter/HorizontalPageCounter.js";
import { Button as f } from "../Button/Button.js";
import { Tooltip as W } from "../Tooltip/Tooltip.js";
const j = ({ confirmTooltip: c, submitText: P, onSubmit: g, className: h, children: p }) => {
  const [o, x] = b(0), C = (e, n, r) => {
    const v = r.filter((l, N) => N < n).every((l) => l.props.valid || l.props.valid === void 0);
    return (e.valid || e.valid === void 0) && v;
  }, t = z(
    () => p.filter((e) => E(e) && e.props).map((e) => e).map((e, n, r) => ({
      ...e.props,
      valid: C(e.props, n, r),
      loading: e.props.loading ?? !1,
      element: e
    })) ?? [],
    [p]
  ), m = o === t.length - 1, a = async (e) => {
    const { onPageSave: n, onBeforePageChange: r } = t[o];
    n?.(e), !(r && await Promise.resolve(r({ currentPage: o, targetPage: e })) === !1) && x(e);
  }, s = () => {
    m ? g() : a(o + 1);
  }, y = () => {
    a(o - 1);
  };
  return S(() => (document.addEventListener(u.ConfirmAndGoToNext, s), () => {
    document.removeEventListener(u.ConfirmAndGoToNext, s);
  })), /* @__PURE__ */ d(L, { gap: 4, align: "stretch", direction: "column", className: h, children: [
    /* @__PURE__ */ i(
      V,
      {
        currentPageIndex: o,
        pages: t,
        onNavigateToPage: (e) => {
          a(e);
        }
      }
    ),
    t.map((e, n) => n === o && e.element),
    /* @__PURE__ */ i(T, {}),
    /* @__PURE__ */ d(A, { children: [
      o > 0 ? /* @__PURE__ */ d(f, { type: "button", appearance: "accent", variant: "secondary", onClick: y, children: [
        "Previous: ",
        t[o - 1].label
      ] }) : /* @__PURE__ */ i("span", {}),
      /* @__PURE__ */ i(W, { show: !!c && t[o].valid, tooltip: c ?? "", children: /* @__PURE__ */ i(
        f,
        {
          type: "button",
          appearance: "accent",
          variant: "primary",
          onClick: s,
          loading: t[o].loading,
          disabled: !t[o].valid,
          children: m ? `${P}` : `Next: ${t[o + 1].label}`
        }
      ) })
    ] })
  ] });
};
j.displayName = "StepWizard";
export {
  j as StepWizard
};
//# sourceMappingURL=StepWizard.js.map
